import { EPrescriptionType } from '@/utils/enums/goods';
import { EPlatform } from '@/utils/enums/platform-enum';

interface FaceWidthMeasurementAvailabilityInput {
  isUk: boolean;
  deviceType: EPlatform;
}

export function isFaceWidthMeasurementEntryAvailable({
  isUk,
  deviceType,
}: FaceWidthMeasurementAvailabilityInput) {
  return isUk && deviceType === EPlatform.WAP;
}

const PRESCRIPTION_PD_MEASUREMENT_TYPES = new Set<EPrescriptionType>([
  EPrescriptionType.SINGLE_VISION,
  EPrescriptionType.READING_GLASSES,
  EPrescriptionType.PRESCRIPTION_READING,
  EPrescriptionType.SUNGLASSES_PRESCRIPTION,
]);

export function isPrescriptionPdMeasurementTypeSupported(prescriptionType: EPrescriptionType) {
  return PRESCRIPTION_PD_MEASUREMENT_TYPES.has(prescriptionType);
}

interface PrescriptionPdMeasurementSurfaceAvailabilityInput
  extends FaceWidthMeasurementAvailabilityInput {
  prescriptionType: EPrescriptionType;
}

export function isPrescriptionPdMeasurementSurfaceAvailable({
  isUk,
  deviceType,
  prescriptionType,
}: PrescriptionPdMeasurementSurfaceAvailabilityInput) {
  return (
    isFaceWidthMeasurementEntryAvailable({ isUk, deviceType }) &&
    isPrescriptionPdMeasurementTypeSupported(prescriptionType)
  );
}

interface PrescriptionPdMeasurementAvailabilityInput
  extends PrescriptionPdMeasurementSurfaceAvailabilityInput {
  isTwoPd: boolean;
}

export function isPrescriptionPdMeasurementEntryAvailable({
  isUk,
  deviceType,
  prescriptionType,
  isTwoPd,
}: PrescriptionPdMeasurementAvailabilityInput) {
  return (
    isPrescriptionPdMeasurementSurfaceAvailable({ isUk, deviceType, prescriptionType }) && !isTwoPd
  );
}
